import React from 'react';
import Select from 'react-select';
import { useRateStore } from '../store/RateStore';
import { getAvailableUnits } from '../models/RateUnits';
import { TankersGroupType } from '_legacy/models/TankersGroupTypes';

const Unit = (props) => {
    const store = useRateStore();

    const handleUnitChange = (newUnit) => {
        store.onChangeUnit(newUnit);
        store.setIsUnitSelectedByUser(true);
    };
    return (
        <div
            className="inline"
            style={{
                width: '100px',
            }}
        >
            <Select
                id="UnitInputA"
                ref={props.unitInputRef}
                className="basic-single"
                classNamePrefix="list"
                isSearchable={false}
                options={getAvailableUnits(
                    props.data.type,
                    props.data?.tankersGroupType,
                    props.data?.datasetId
                )}
                menuPlacement="auto"
                onChange={handleUnitChange}
                value={store.unit}
                openMenuOnFocus={true}
            />
        </div>
    );
};

export default Unit;
